export const CREATE_IDEAS_TOUR_ID = 'create-ideas-tour-spotlight';
export const CREATE_IDEAS_TOUR_STEP_1_SPOTLIGHT_ID = 'create-ideas-tour-step-1-spotlight';
